function Bookmark() {

  /* Custom bookmark */
  
  return (
    <div id="bookmark">
      <div className="bookmark-section" id="intro">
        <h1>
          {">"}
          {">"} JENNE HUI
        </h1>
        <p>
          Full-Stack Software Developer
          <br/>
          @ Conexiom
          <br/>
          <br/>
          <span>&nbsp; About me: &nbsp;</span>
          <br/>
          ~ Hi, Jenne here!
          <br/>
          <br/>
          I am a <b>curiosity-driven</b> software dev
          <br/>
          currently working in the document
          <br/>
          automation space.
          <br/><br/>
          Let's build something functional and beautiful together :)
        </p>
        <p>Thanks for visiting my site!<br/>ᕙ(⇀‸↼‶)ᕗ</p>
        <br/>
      </div>
      <div className="bookmark-section" id="quests">
        <p>
          <span>&nbsp; What I am up to: &nbsp;</span>
          <br/>
        </p>
        <p className="align-left">
          - optimizing my Stardew Valley farm
          <br/>
          - violining lots
          <br/>
          - LeetCoding for days :^)
          <br/>
        </p>
        <br/>
      </div>
      <div className="bookmark-section" id="contact">
        <p>
          <span className="align-label-left">&nbsp; Find me: &nbsp;</span>&nbsp;
          <a href="mailto:jenne.hui@gmail.com">@ Email</a>&nbsp;|&nbsp;
          <a href="https:/github.com/Castaire" target="_blank" rel="noreferrer">
            @ Github
          </a>
          &nbsp;|&nbsp;
          <a href="https://linkedin.com/in/jenne-hui" target="_blank" rel="noreferrer">
            @LinkedIn
          </a>
        </p>
        <p>
          <span className="align-label-left">&nbsp; Resumé: &nbsp;&nbsp;</span>&nbsp;
          <a href="/resume2026-jenne-hui.pdf"target="_blank" rel="noreferrer">
            right here!
          </a>
        </p>
      </div>
    </div>
  );
}

export default Bookmark;